"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const config = __importStar(require("../../config"));
const vue_1 = __importDefault(require("vue"));
const statefulpromise_1 = require("@/utils/statefulpromise");
const transformations_1 = require("@/utils/transformations");
const ENABLE_LOGGING = false;
exports.ERR_OBJECT_NOT_FOUND = Error("Object not found");
function initialState() {
    return {
        exercises: {
            data: [],
            next: "",
            isLoading: false
        },
        exerciseLists: {
            data: [],
            next: "null",
            isLoading: false,
            pages: {}
        },
        exerciseDetails: {},
    };
}
const getters = {
    detail: (state) => (slug) => {
        if (state.exerciseDetails[slug]) {
            const item = Object.assign({}, state.exerciseDetails[slug]);
            if (item && item.data && item.data.levels) {
                item.data.unpacked = transformations_1.unpackData(item.data.levels, item.data.primary_unit);
                item.data.isChallenge = Object.keys(item.data.unpacked).length === 1;
            }
            return item;
        }
        return undefined;
    },
};
const mutations = {
    prependPrivateExercise: (state, payload) => {
        const next = Object.assign({}, state.exercises);
        next.data.unshift(payload);
        state.exercises = next;
    },
    clearPrivateData: (state, payload) => {
        for (const exercise of state.exercises.data) {
            vue_1.default.delete(state.exerciseDetails, exercise.slug);
        }
        state.exercises = {
            data: [],
            next: "",
            isLoading: false
        };
    },
    replaceExercise: (state, payload) => {
        // replace by slug
        if (payload.slug && state.exerciseDetails[payload.slug]) {
            vue_1.default.set(state.exerciseDetails, payload.slug, payload);
        }
        // replace by uuid key
        let key = undefined;
        if (payload.uuid) {
            key = 'uuid/' + payload.uuid;
        }
        if (key && state.exerciseDetails[key]) {
            vue_1.default.set(state.exerciseDetails, key, payload);
        }
        // private exercises
        const next = Object.assign({}, state.exercises);
        next.data = next.data.map((exercise) => {
            // search and replace instances of edit
            return (exercise.uuid === payload.uuid) ? payload : exercise;
        });
        state.exercises = next;
        // replace in public
        const pub = Object.assign({}, state.exerciseLists);
        pub.data = pub.data.map((exercise) => {
            // search and replace instances of edit
            return (exercise.uuid === payload.uuid) ? payload : exercise;
        });
        // replace in public (paged)
        for (const k in pub.pages) {
            pub.pages[k].data = pub.pages[k].data.map((exercise) => {
                // search and replace instances of edit
                return (exercise.uuid === payload.uuid) ? payload : exercise;
            });
        }
        state.exerciseLists = pub;
    },
    setPrivateExercises: (state, payload) => {
        const next = Object.assign({}, state.exercises);
        if (ENABLE_LOGGING)
            console.log("setExercises called: ", payload);
        if (Array.isArray(payload.data)) {
            next.data.push(...payload.data);
        }
        if (payload.hasOwnProperty('next')) {
            next.next = payload.next;
        }
        if (payload.hasOwnProperty('isLoading')) {
            next.isLoading = payload.isLoading;
        }
        state.exercises = next;
    },
    setExercises: (state, payload) => {
        if (payload && payload.key) {
            if (ENABLE_LOGGING)
                console.log("setExercises - 1");
            const key = payload.key;
            if (ENABLE_LOGGING)
                console.log("key - 2: ", key);
            if (ENABLE_LOGGING)
                console.log("key - 2 type : ", typeof key);
            vue_1.default.set(state.exerciseLists.pages, key, {});
            if (payload.hasOwnProperty('data')) {
                vue_1.default.set(state.exerciseLists.pages[key], 'data', payload.data);
            }
            if (payload.hasOwnProperty('next')) {
                vue_1.default.set(state.exerciseLists.pages[key], 'next', payload.next);
            }
            if (payload.hasOwnProperty('previous')) {
                vue_1.default.set(state.exerciseLists.pages[key], 'previous', payload.previous);
            }
            if (payload.hasOwnProperty('isLoading')) {
                vue_1.default.set(state.exerciseLists.pages[key], 'isLoading', payload.isLoading);
            }
            if (ENABLE_LOGGING)
                console.log("list key: ", state.exerciseLists.next);
            if (ENABLE_LOGGING)
                console.log("list key type: ", typeof state.exerciseLists.next);
            if (key === state.exerciseLists.next) {
                if (ENABLE_LOGGING)
                    console.log("key matched: ", key);
                if (payload.hasOwnProperty('isLoading') && payload.isLoading) {
                    vue_1.default.set(state.exerciseLists, 'isLoading', true);
                }
                else {
                    if (payload.hasOwnProperty('data') && Array.isArray(payload.data)) {
                        state.exerciseLists.data.push(...payload.data);
                    }
                    let next = payload.next;
                    do {
                        if (next && state.exerciseLists.pages[next]) {
                            if (state.exerciseLists.pages[next].isLoading) {
                                // next page is already loading, but not done yet
                                state.exerciseLists.isLoading = true;
                                state.exerciseLists.next = next;
                                break;
                            }
                            else {
                                // next page is already done loading and data is present
                                if (Array.isArray(state.exerciseLists.pages[next].data)) {
                                    state.exerciseLists.data.push(...state.exerciseLists.pages[next].data);
                                }
                                next = state.exerciseLists.pages[next].next;
                                state.exerciseLists.next = next;
                            }
                        }
                        else {
                            // next page hasn't started loading yet
                            state.exerciseLists.isLoading = false;
                            state.exerciseLists.next = next;
                            break;
                        }
                    } while (next);
                }
            }
        }
    },
    setExerciseDetails: (state, payload) => {
        const key = payload.key;
        const data = payload.data;
        const err = payload.error;
        if (payload.key) {
            vue_1.default.set(state.exerciseDetails, key, { data: data, error: err });
        }
    },
    deleteExercise: (state, payload) => {
        if (ENABLE_LOGGING)
            console.log("delete exercise called: ", payload);
        if (payload) {
            const slug = payload.slug;
            if (slug) {
                // delete details by slug
                vue_1.default.delete(state.exerciseDetails, slug);
            }
            const uuid = payload.uuid;
            let key = undefined;
            if (payload.uuid) {
                // delete details by uuid
                key = 'uuid/' + payload.uuid;
                vue_1.default.delete(state.exerciseDetails, key);
            }
            // delete by either slug AND uuid
            const filterFn = (item) => item.slug !== slug && item.uuid !== uuid;
            // delete from private list
            state.exercises.data = state.exercises.data.filter(filterFn);
            // delete from public list (all items)
            state.exerciseLists.data = state.exerciseLists.data.filter(filterFn);
            // delete from public list (paged items)
            for (const key in state.exerciseLists.pages) {
                state.exerciseLists.pages[key].data = state.exerciseLists.pages[key].data.filter(filterFn);
            }
        }
        if (payload && payload.uuid) {
            const uuid = payload.uuid;
            // TODO search through workout lists and delete it
        }
    },
};
function makeExerciseModule(httpClient) {
    const module = {
        namespaced: true,
        state: initialState(),
        getters: getters,
        actions: makeActions(httpClient),
        mutations: mutations
    };
    return module;
}
exports.default = makeExerciseModule;
function makeActions(httpClient) {
    let INFLIGHT_EXERCISES;
    const INFLIGHT_EXERCISE_LISTS = {};
    const INFLIGHT_EXERCISE_DETAILS = {};
    const actions = {
        createExercise(context, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield httpClient.post(config.BASE_API + '/training/exercises', payload);
                    const slug = response.data.slug;
                    const id = response.data.id;
                    const data = {
                        id: id,
                        slug: slug,
                        user_id: payload.user_id,
                        uuid: payload.uuid,
                        name: payload.name,
                        description: payload.description,
                        primary_unit: payload.primary_unit,
                        levels: payload.levels
                    };
                    context.commit('prependPrivateExercise', data);
                    context.commit('setExerciseDetails', {
                        key: slug,
                        data: data,
                    });
                }
                catch (err) {
                    if (ENABLE_LOGGING)
                        console.log(err);
                    throw err;
                }
            });
        },
        updateExercise(context, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const uuid = payload.uuid;
                    const url = config.BASE_API + '/training/exercises/uuid/' + uuid;
                    const response = yield httpClient.put(url, payload);
                    const slug = payload.slug;
                    const id = payload.id;
                    const data = {
                        id: id,
                        slug: slug,
                        user_id: payload.user_id,
                        uuid: uuid,
                        name: payload.name,
                        description: payload.description,
                        primary_unit: payload.primary_unit,
                        levels: payload.levels
                    };
                    if (slug) {
                        context.commit('setExerciseDetails', {
                            key: slug,
                            data: data,
                        });
                    }
                    context.commit('setExerciseDetails', {
                        key: 'uuid/' + uuid,
                        data: data,
                    });
                    context.commit('replaceExercise', data);
                }
                catch (err) {
                    if (ENABLE_LOGGING)
                        console.log(err);
                    throw err;
                }
            });
        },
        deleteExercise(context, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const url = config.BASE_API + '/training/exercises/uuid/' + payload.uuid;
                    const response = yield httpClient.delete(url);
                    context.commit('deleteExercise', {
                        uuid: payload.uuid,
                        slug: payload.slug
                    });
                }
                catch (err) {
                    if (ENABLE_LOGGING)
                        console.log(err);
                    throw err;
                }
            });
        },
        listPrivateExercises(context, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (context.state.exercises.isLoading) {
                        return INFLIGHT_EXERCISES;
                    }
                    else {
                        const pos = context.state.exercises.next;
                        // if ((!pos && context.state.exercises.data.length > 0)
                        //     || (!payload.more && context.state.exercises.data.length > 0)) {
                        if (!payload.more && pos) {
                            return null;
                        }
                        const url = config.BASE_API + '/me/exercises' + (pos ? '?pos=' + pos : '');
                        INFLIGHT_EXERCISES = statefulpromise_1.toStatefulPromise(httpClient.get(url));
                        context.commit('setPrivateExercises', {
                            isLoading: true
                        });
                        const response = yield INFLIGHT_EXERCISES;
                        const data = response.data.data.filter((exercise) => exercise.name);
                        context.commit('setPrivateExercises', {
                            data: data,
                            next: response.data.next,
                            isLoading: false
                        });
                        return response;
                    }
                }
                catch (err) {
                    if (ENABLE_LOGGING)
                        console.log(err);
                    throw err;
                }
            });
        },
        listExercises(context, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const pos = payload && payload.pos ? payload.pos : "null";
                    if (INFLIGHT_EXERCISE_LISTS[pos] && !INFLIGHT_EXERCISE_LISTS[pos].isRejected()) {
                        return yield INFLIGHT_EXERCISE_LISTS[pos];
                    }
                    else {
                        const url = config.BASE_API + '/training/exercises' + (pos !== "null" ? '?pos=' + pos : '');
                        INFLIGHT_EXERCISE_LISTS[pos] = statefulpromise_1.toStatefulPromise(httpClient.get(url));
                        context.commit('setExercises', {
                            key: pos,
                            isLoading: true
                        });
                        const response = yield INFLIGHT_EXERCISE_LISTS[pos];
                        const data = {
                            key: pos,
                            data: response.data.data,
                            next: response.data.next,
                            previous: response.data.previous,
                            isLoading: false
                        };
                        context.commit('setExercises', data);
                        return data;
                    }
                }
                catch (err) {
                    if (ENABLE_LOGGING)
                        console.log(err);
                    throw err;
                }
            });
        },
        moreExercises(context, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const more = !!(payload && payload.more);
                    const pos = context.state.exerciseLists.next;
                    if (INFLIGHT_EXERCISE_LISTS[pos] && !INFLIGHT_EXERCISE_LISTS[pos].isRejected()) {
                        return yield INFLIGHT_EXERCISE_LISTS[pos];
                    }
                    else if (pos === 'null' || more) {
                        const url = config.BASE_API + '/training/exercises' + (pos !== "null" ? '?pos=' + pos : '');
                        INFLIGHT_EXERCISE_LISTS[pos] = statefulpromise_1.toStatefulPromise(httpClient.get(url));
                        context.commit('setExercises', {
                            key: pos,
                            isLoading: true
                        });
                        const response = yield INFLIGHT_EXERCISE_LISTS[pos];
                        context.commit('setExercises', {
                            key: pos,
                            data: response.data.data,
                            next: response.data.next,
                            previous: response.data.previous,
                            isLoading: false
                        });
                        return response;
                    }
                    else {
                        return false;
                    }
                }
                catch (err) {
                    if (ENABLE_LOGGING)
                        console.log(err);
                    throw err;
                }
            });
        },
        getExercise(context, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                const key = payload.key;
                try {
                    if (!key) {
                        throw Error("NO EXERCISE KEY");
                    }
                    if (INFLIGHT_EXERCISE_DETAILS[key] && !INFLIGHT_EXERCISE_DETAILS[key].isRejected()) {
                        return yield INFLIGHT_EXERCISE_DETAILS[key];
                    }
                    else {
                        const url = config.BASE_API + '/training/exercises/' + key;
                        INFLIGHT_EXERCISE_DETAILS[key] = statefulpromise_1.toStatefulPromise(httpClient.get(url));
                        const response = yield INFLIGHT_EXERCISE_DETAILS[key];
                        if (typeof response.data.user_id === 'number') {
                            response.data.user_id = response.data.user_id.toString(10);
                        }
                        context.commit('setExerciseDetails', {
                            key: key,
                            data: response.data
                        });
                        // remove key inflight list, to make sure this can be called again for fresh data
                        delete INFLIGHT_EXERCISE_DETAILS[key];
                        return response;
                    }
                }
                catch (err) {
                    // TODO create error handling helper function
                    if (err && err.response && err.response.status === 404) {
                        context.commit('setExerciseDetails', {
                            key: key,
                            error: 'not found'
                        });
                        throw exports.ERR_OBJECT_NOT_FOUND;
                    }
                    else {
                        throw err;
                    }
                }
            });
        },
        clearPrivateData(context, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                if (ENABLE_LOGGING)
                    console.log("clearing private data");
                context.commit('clearPrivateData', null);
            });
        },
    };
    return actions;
}
